module.exports = __webpack_public_path__ + "img/grunge-noise.096f3885.jpg";